import { AxiosError } from "axios";
import EventEmitter from "eventemitter3";

let _translate: ((key: string) => string) | null = null

import("@/i18n").then(({ i18n }) => {
  _translate = i18n.global.t
}).catch(() => { /* not available in test env */ })

export const events = new EventEmitter<{
  success: [{
    title?: string;
    message: string;
  }]
  error: [{
    title?: string;
    message: string;
  }]
  warning: [{
    title?: string;
    message: string;
  }]
  info: [{
    title?: string;
    message: string;
  }]
}>();

export function success(message: string, title: string = "Sucesso") {
  events.emit('success', {
    title,
    message,
  })
}

export function error(message: string, title: string = "Erro") {
  events.emit('error', {
    title,
    message,
  })
}

export function warning(message: string, title: string = "Aviso") {
  events.emit('warning', {
    title,
    message
  })
}

export function info(message: string, title: string = "Informação") {
  events.emit('info', {
    title,
    message
  })
}

function translateErrorMessage(message: string): string {
  if (message.startsWith('errors.') && _translate) {
    const key = `toast_errors.${message.replace('errors.', '')}`
    const translated = _translate(key)
    if (translated !== key) return translated
  }
  return message
}

export function exception(err: unknown) {
  if (err instanceof AxiosError && err.response?.data?.error) {
    const errData = err.response.data.error
    const message = errData.message ?? errData
    error(translateErrorMessage(typeof message === 'string' ? message : String(message)))
    return
  }
  if (err instanceof AxiosError && err.response?.data?.errorMessage) {
    error(translateErrorMessage(err.response.data.errorMessage))
    return
  }
  const axiosLike = err as { response?: { data?: string }; message?: string } | null;
  if (axiosLike?.response?.data) {
    const errorData = JSON.parse(axiosLike.response.data)
    let msg = ''
    for (const indice in errorData) {
      msg += errorData[indice][0] + '<br>'
    }
    if (msg !== '') {
      error(msg, 'Erro')
    }
  } else if (axiosLike?.message) {
    error(axiosLike.message, 'Erro')
  } else {
    error('Erro desconhecido', 'Erro')
  }
}